import {MediaQueries} from '../../infra/mediaQueries.service';
import {Component, Input} from 'ng-metadata/core';
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';


@Component({
    selector: 'prm-banner-card-content',
    templateUrl: 'components/search/resourceRecommender/banner-card-content.html',
})

export class PrmBannerCardContent {
    @Input() private banner;

    constructor(private primolyticsService: PrimolyticsService) {
		this.bannerDisplayedBeacon();
    }

    private onBannerClick() {
        this.onBannerClickBeacon();
    }

    @beacon({'p':'brief', 'op': 'resourceRecommenderBanner'})
    private onBannerClickBeacon() {
    }

    @beacon({'p':'brief', 'op': 'resourceRecommenderBannerDisplayed'})
    private bannerDisplayedBeacon() {
    }

}






// WEBPACK FOOTER //
// ./src/main/webapp/components/search/resourceRecommender/bannerCardContent.directive.ts